
import React, { useState } from 'react';
import { Container, Row, Col, Badge, Button, Collapse, Image } from 'react-bootstrap';
import { FaBuilding } from 'react-icons/fa';

const FaBuildingIcon = FaBuilding as any;

const experiences = [
    {
    role: 'VP of Engineering',
    company: 'Wallester',
    website: 'https://wallester.com',
    description: 'Leading Engineering to accelerate product and platform development, improve delivery predictability, and scale infrastructure with reliability and ownership. Focused on building high-performing teams and driving measurable business outcomes in a fast-growing fintech environment.',
    current: true,
    logo: 'https://wallester.com/favicon.ico'
  },
  {
    role: 'Chief Technology Officer',
    company: 'NoOnes',
    website: 'https://noones.com',
    description: 'Accountable for the overarching technology vision, strategy, and execution. Leading the development of the NoOnes platform, ensuring robust, scalable, and secure infrastructure, and overseeing product development and data security.',
    logo: 'https://noones.com/assets/images/favicons/android-chrome-192x192.png'
  },
  {
    role: 'Chief Technology Officer',
    company: 'Paxful',
    website: 'https://paxful.com',
    description: 'Directed the engineering department during a phase of significant user growth and platform scaling. Responsible for the strategic development and launch of new products and features, enhancing platform reliability and performance.',
    logo: '/paxful.ico'
  },
  {
    role: 'Vice President of Infrastructure and Data Engineering',
    company: 'Paxful',
    website: 'https://paxful.com',
    description: 'Established and led the infrastructure and data engineering teams. Successfully scaled the platform to support a rapidly growing user base and high transaction volumes, ensuring high availability and data integrity.',
    logo: '/paxful.ico'
  },
  {
    role: 'Director of Infrastructure and Data Engineering',
    company: 'Paxful',
    website: 'https://paxful.com',
    description: 'Led the successful migration to a modern, cloud-native infrastructure. Implemented and enforced best practices for site reliability engineering (SRE), security, and data governance across the organization.',
    logo: '/paxful.ico'
  },
  {
    role: 'Site Reliability Engineering Manager',
    company: 'Malwarebytes',
    website: 'https://www.malwarebytes.com',
    description: 'Managed a team of Site Reliability Engineers focused on ensuring the high availability and performance of Malwarebytes Account services. Led initiatives to improve deployment automation, CI/CD pipelines, and incident response protocols.',
    logo: 'https://static.cdnlogo.com/logos/m/52/malwarebytes.svg'
  },
  {
    role: 'Chief Technology Officer',
    company: 'Eurobyte',
    website: 'https://eurobyte.ru',
    description: 'Developed and executed the company\'s technology strategy, overseeing the development of new products and services. Focused on improving operational efficiency and driving innovation.',
    logo: 'https://eurobyte.ru/favicon.ico'
  },
  {
    role: 'Chief Technology Officer',
    company: 'McHost',
    website: 'https://mchost.ru',
    description: 'Led the technology team, with a focus on improving service delivery and customer satisfaction. Responsible for the company\'s technology infrastructure, including network, servers, and storage.',
    logo: 'https://mchost.ru/favicon.ico'
  }
];

const Experience: React.FC = () => {
  const [open, setOpen] = useState<{ [key: number]: boolean }>({});

  return (
    <section id="experience" className="py-5 bg-light">
      <Container>
        <h2 className="text-center mb-4">Experience</h2>
        <Row className="justify-content-center">
          {experiences.map((exp, index) => (
            <Col md={10} key={index} className="mb-3">
              <Button
                onClick={() => setOpen(prevOpen => ({ ...prevOpen, [index]: !prevOpen[index] }))}
                aria-controls={`collapse-${index}`}
                aria-expanded={open[index]}
                className="w-100 text-start"
                variant="light"
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span>
                    <b>{exp.role}</b> at {exp.company}
                    {exp.logo ? (
                      <Image src={exp.logo} alt={`${exp.company} logo`} height="24" className="ms-2" />
                    ) : (
                      <FaBuildingIcon className="ms-2" />
                    )}
                  </span>
                  {exp.current && (
                    <Badge bg="success" className="ms-2">
                      Current
                    </Badge>
                  )}
                </div>
              </Button>
              <Collapse in={open[index]}>
                <div id={`collapse-${index}`} className="mt-3">
                  <p>{exp.description}</p>
                </div>
              </Collapse>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Experience;
